import {DocumentUIField} from '@/engine';
import {FieldProps} from '../../meta-field';

export const SpacerField = ({field}: FieldProps<DocumentUIField>) => {
  return <div data-testid={field.id}></div>;
};
